import { useUnmount } from 'react-use';

import { VisitStatus, VisitStatusDetails, VisitStatusDetailsQuery } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';
import { Slot } from '@dreryk/watermelon';

import { useVisitStatusGlobalState } from './VisitStatusResolver.hooks';

type VisitStatusResolverProps = {
   visitIds: number[];
};

export const VisitStatusResolver = (options: VisitStatusResolverProps): null => {
   const { updateStatus, resetStatus } = useVisitStatusGlobalState();

   useCqrsSearch<VisitStatusDetails>(
      () => {
         const query = new VisitStatusDetailsQuery();
         query.visitIds = Slot.of(options.visitIds);
         return query;
      },
      paginations.all(),
      {
         onSuccess: (visitStatusDetails) => {
            updateStatus(
               options.visitIds
                  .map<[number, VisitStatus | null]>((id) => [id, null])
                  .concat(visitStatusDetails.map(({ id, status }) => [id, status]))
            );
         },
      }
   );

   useUnmount(resetStatus);

   return null;
};
